import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-app-message',
  templateUrl: './app-message.component.html',
  styleUrls: ['./app-message.component.scss'],
})
export class AppMessageComponent {
  constructor(private modalService: NgbModal, private router: Router) {}
  @Input() showMsg?: boolean = false;
}
